import React, { useEffect, useState, useRef, useCallback } from "react";

import "./App.css";
import Canvas from "./componentes/Canvas";
function App() {
  // const [estadoLoading, setEstadoLoading] = useState(false);
  // const completo = (valor) => {
  //   // console.log("completado es, ", valor);
  //   setEstadoLoading(valor);
  // };
  return <Canvas />;
  // if ("ontouchstart" in window || navigator.msMaxTouchPoints > 0) {
  //   return (
  //     <>
  //       <p>Prueba numero uno</p>
  //     </>
  //   );
  // } else {
  //   if (!estadoLoading) {
  //     return <p>Cargando</p>;
  //   } else {
  //     return <p>Completado</p>;
  //   }
  //   // return <Canvas />;
  // }

  return (
    <>
      {/* <Container fluid> */}
      {/* <Canvas
        pausa={pausa}
        cambiarEtiqueta={cambiarEtiqueta}
        girarIzquierda={girarIzquierda}
        girarDerecha={girarDerecha}
        colorTapa={color}
        cambiarColor={cambiarColor}
        etiqueta1={etiqueta1}
        etiqueta2={etiqueta2}
        etiqueta3={etiqueta3}
      /> */}
      {/* <Container fluid style={{ height: "100vh" }}> */}
      {/* <Row>
          <Col md={10} className="mx-auto d-block"></Col>
        </Row> */}

      {/* <section className="section">
          <Cubo />
        </section> */}
      {/* </Container> */}
      {/* <section className="section">
        <h2>Contact me</h2>
      </section> */}
      {/* </Container> */}
    </>
  );
}

export default App;

{
  /* <div className="text-center">
  <canvas
    className="webgl2"
    // ref={refDiv}
    style={{ zIndex: "1" }}
  ></canvas>
  <div>
    <p>Descripción del tipo de lente numero 1</p>
  </div>
</div> */
}
